import { useEffect, useState } from "react";

export const DESKTOP_MEDIA_QUERY = "(min-width: 1120px)";

export function mediaQueryIsDesktop(mediaQueryList) {
  return mediaQueryList?.matches === true;
}

export function useDesktopViewport() {
  const [isDesktop, setIsDesktop] = useState(() => mediaQueryIsDesktop(window.matchMedia(DESKTOP_MEDIA_QUERY)));

  useEffect(() => {
    const query = window.matchMedia(DESKTOP_MEDIA_QUERY);
    const update = (event) => setIsDesktop(mediaQueryIsDesktop(event));
    setIsDesktop(mediaQueryIsDesktop(query));
    query.addEventListener("change", update);
    return () => query.removeEventListener("change", update);
  }, []);

  return isDesktop;
}
